import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useAuthStore } from "../../../store/authStore";
import { useNavigationStore } from "../../../store/navigationStore";
import SideBar from "components/nav/SideBar";
import { Content, MainContainer } from "styles/styles";
import { useModal } from "../../../store/modalStore";
import { ReactComponent as LogoIcon } from "@/assets/logo/union_ver1.svg?react";

import {
  Container,
  Header,
  Title,
  Description,
  Form,
  Input,
  Textarea,
  Button,
} from "./styles";

const ContactPage: React.FC = () => {
  const { user } = useAuthStore();
  const showSideBar = !!user;
  const { isCollapsed } = useNavigationStore();
  const { openInfo } = useModal();

  const [form, setForm] = useState({
    name: "",
    email: "",
    title: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const serviceID = "service_agv5ath";
    const templateID = "template_mkigjgo";
    const publicKey = "iS8mwwapHuui68tiI";

    try {
      await emailjs.send(serviceID, templateID, form, publicKey);
      openInfo({
        title: "감사합니다!",
        message: "문의가 정상적으로 접수되었습니다. 빠르게 회신드릴게요."
      });
      setForm({ name: "", email: "", title: "", message: "" });
    } catch (error) {
      openInfo({  
        title: "전송 실패",
        message: "문의를 보내는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
      });
    }
  };

  const content = (
    <Container>
      <LogoIcon style={{ width: "32px", height: "30px" }} />

      <Header>
        <Title>Audion 팀에게 피드백 보내기</Title>
        <Description>
          서비스 사용 중 불편한 점이나 새로운 아이디어가 있으신가요? <br />
          여러분의 의견이 Audion을 더 나은 방향으로 성장시킵니다.
        </Description>
      </Header>

      <Form onSubmit={handleSubmit}>
        <Input
          name="name"
          placeholder="이름"
          value={form.name}
          onChange={handleChange}
          required
        />
        <Input
          type="email"
          name="email"
          placeholder="이메일 (예: user@company.com)"
          value={form.email}
          onChange={handleChange}
          required
        />
        <Input
          name="title"
          placeholder="제목"
          value={form.title}
          onChange={handleChange}
          required
        />
        <Textarea
          name="message"
          placeholder="문의 내용을 입력해주세요."
          value={form.message}
          onChange={handleChange}
          required
        />
        <Button type="submit">보내기</Button>
      </Form>
    </Container>
  );

  return (
    <MainContainer>
      {showSideBar ? (
        <Content $isCollapsed={isCollapsed}>
          <SideBar />
          {content}
        </Content>
      ) : (
        content
      )}
    </MainContainer>
  );
};

export default ContactPage;
